import { render, staticRenderFns } from "./CartoucheFicheA4.vue?vue&type=template&id=2713503f&"
import script from "./CartoucheFicheA4.vue?vue&type=script&lang=js&"
export * from "./CartoucheFicheA4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports